/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationDetailsServicesBox_ViewerOrganisationFragment = { __typename: 'ViewerOrganisation', id: string, categories: Array<string>, serviceArea: string };

export type OrganisationDetailsServicesBox_ModifyOrganisationMutationVariables = Types.Exact<{
  input: Types.OrganisationUpdateInput;
}>;


export type OrganisationDetailsServicesBox_ModifyOrganisationMutation = { updateOrganisation: { __typename: 'OrganisationUpdateResult', organisation: { __typename: 'ViewerOrganisation', id: string, categories: Array<string>, serviceArea: string } } };

export const OrganisationDetailsServicesBox_ViewerOrganisationFragmentDoc = gql`
    fragment OrganisationDetailsServicesBox_ViewerOrganisation on ViewerOrganisation {
  id
  categories
  serviceArea
}
    `;
export const OrganisationDetailsServicesBox_ModifyOrganisationDocument = gql`
    mutation OrganisationDetailsServicesBox_ModifyOrganisation($input: OrganisationUpdateInput!) {
  updateOrganisation(input: $input) {
    organisation {
      id
      categories
      serviceArea
    }
  }
}
    `;
export type OrganisationDetailsServicesBox_ModifyOrganisationMutationFn = Apollo.MutationFunction<OrganisationDetailsServicesBox_ModifyOrganisationMutation, OrganisationDetailsServicesBox_ModifyOrganisationMutationVariables>;

/**
 * __useOrganisationDetailsServicesBox_ModifyOrganisationMutation__
 *
 * To run a mutation, you first call `useOrganisationDetailsServicesBox_ModifyOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationDetailsServicesBox_ModifyOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationDetailsServicesBoxModifyOrganisationMutation, { data, loading, error }] = useOrganisationDetailsServicesBox_ModifyOrganisationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationDetailsServicesBox_ModifyOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationDetailsServicesBox_ModifyOrganisationMutation, OrganisationDetailsServicesBox_ModifyOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationDetailsServicesBox_ModifyOrganisationMutation, OrganisationDetailsServicesBox_ModifyOrganisationMutationVariables>(OrganisationDetailsServicesBox_ModifyOrganisationDocument, options);
      }
export type OrganisationDetailsServicesBox_ModifyOrganisationMutationHookResult = ReturnType<typeof useOrganisationDetailsServicesBox_ModifyOrganisationMutation>;
export type OrganisationDetailsServicesBox_ModifyOrganisationMutationResult = Apollo.MutationResult<OrganisationDetailsServicesBox_ModifyOrganisationMutation>;
export type OrganisationDetailsServicesBox_ModifyOrganisationMutationOptions = Apollo.BaseMutationOptions<OrganisationDetailsServicesBox_ModifyOrganisationMutation, OrganisationDetailsServicesBox_ModifyOrganisationMutationVariables>;